import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Header from './components/Header.jsx';
import './components/custom-style.css';
import Home from './pages/Home.jsx';
import Login from './pages/Login.jsx';
import OAuthCallback from './pages/OAuthCallback';
import './index.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Logout from './pages/Logout';
import { ensureTokenValidity } from './auth/auth.js';
import { jwtDecode } from 'jwt-decode';

import { setUser } from './state/actions/userActions';
import { addCard } from './state/actions/cardActions';
import SimulationCardList from './components/SimulationCardList';
import './components/custom-style.css';
import cardsData from './mock-data/cards.json';


function App() {
  const dispatch = useDispatch();
  // const userInfo = useSelector((state) => state.user.userInfo);
  const isAuthenticated = useSelector((state) => state.user.isAuthenticated);


  useEffect(() => {

    ensureTokenValidity((token, user) => {
      // console.log('Token:', token);
      if (token) {
        const decoded = jwtDecode(token);
        localStorage.setItem("authToken", token);
        localStorage.setItem("profile_code", decoded.secto_plan_name);
        console.log('Decoded Token:', decoded.secto_plan_name);
        console.log('User:', user);
      } else {
        console.warn('No valid token found.');
      }

      if (token && !isAuthenticated) {
        dispatch(setUser(token));
      }
    })
  }, [dispatch, isAuthenticated]);

  useEffect(() => {
    cardsData.forEach((card) => {
      dispatch(addCard(card));
    });
  }, [dispatch]);


  return (
    <Router>
      <div className="min-h-screen bg-gray-900 text-white">

        <Header />


        <div className="content p-4 mt-20">



          <SimulationCardList />


          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/logout" element={<Logout />} />
            <Route path="/oauth/callback" element={<OAuthCallback />} />
          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App;